import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusPill from "@/components/StatusPill";

export default function LogsTab({ projectId }) {
  const [logs, setLogs] = useState([]);
  const [stats, setStats] = useState(null);

  async function load() {
    const [l, s] = await Promise.all([
      api.get("/logs/generation", { params: { project_id: projectId } }),
      api.get("/logs/generation/stats", { params: { project_id: projectId } }),
    ]);
    setLogs(l.data); setStats(s.data);
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [projectId]);

  return (
    <div>
      {stats && (
        <div className="grid grid-cols-2 sm:grid-cols-5 mb-4 border border-border">
          <div className="p-3"><div className="text-[10px] txt-mono uppercase text-muted-foreground">Total cost</div><div className="stat-num text-xl text-primary mt-1">${(stats.total_cost_usd || 0).toFixed(4)}</div></div>
          {Object.entries(stats.by_status || {}).map(([k, v], i) => (
            <div key={k} className="p-3 border-l border-border">
              <div className="text-[10px] txt-mono uppercase text-muted-foreground">{k}</div>
              <div className="stat-num text-xl mt-1">{v.count}</div>
              <div className="text-[10px] txt-mono text-muted-foreground">${(v.total_cost || 0).toFixed(4)} · {Math.round(v.avg_time_ms / 1000)}s avg</div>
            </div>
          ))}
        </div>
      )}
      <div className="border border-border overflow-x-auto">
        <table className="w-full text-xs txt-mono">
          <thead>
            <tr className="bg-secondary border-b border-border text-left">
              <th className="px-3 py-2 text-[10px] uppercase tracking-widest text-muted-foreground">Time</th>
              <th className="px-3 py-2 text-[10px] uppercase tracking-widest text-muted-foreground">Model</th>
              <th className="px-3 py-2 text-[10px] uppercase tracking-widest text-muted-foreground">Status</th>
              <th className="px-3 py-2 text-[10px] uppercase tracking-widest text-muted-foreground">Tokens (in/out)</th>
              <th className="px-3 py-2 text-[10px] uppercase tracking-widest text-muted-foreground">Cost</th>
              <th className="px-3 py-2 text-[10px] uppercase tracking-widest text-muted-foreground">Latency</th>
              <th className="px-3 py-2 text-[10px] uppercase tracking-widest text-muted-foreground">Error</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-border last:border-b-0">
                <td className="px-3 py-2 text-muted-foreground">{l.created_at?.slice(0, 19).replace("T", " ")}</td>
                <td className="px-3 py-2">{l.model_used}</td>
                <td className="px-3 py-2"><StatusPill status={l.status} /></td>
                <td className="px-3 py-2 stat-num">{l.tokens_input}/{l.tokens_output}</td>
                <td className="px-3 py-2 stat-num">${(l.cost_usd || 0).toFixed(5)}</td>
                <td className="px-3 py-2 stat-num">{l.generation_time_ms}ms</td>
                <td className="px-3 py-2 text-red-400 max-w-md truncate">{l.error || ""}</td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan={7} className="px-3 py-8 text-center text-muted-foreground">No generation logs yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
